export const currency = (
  amount: number | undefined | null,
  options: { minimumFractionDigits: number } = { minimumFractionDigits: 1 }
): string => {
  return Intl.NumberFormat("en", {
    currency: "USD",
    style: "currency",
    minimumFractionDigits: options.minimumFractionDigits,
  }).format(amount || 0);
};
